import type { Entity } from '@getaccept/lib-shared/src/entity/signing-site/types/entity';

export interface EntityState {
  loading: boolean;
  loaded: boolean;
  entity: Entity;
}

export enum EntityAction {
  Load = 'load',
  LoadSuccess = 'loadSuccess',
}

export enum EntityMutation {
  SetEntity = 'setEntity',
}
